import { useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { BreadCrumbs } from '../../Layout/Header/BreadCrumbs';

import { SalesTaxCreate } from './SalesTaxCreate';

import { AddRecord } from '@components/ActionButtons';
import { BoxHeaderTitle } from '@components/Box';
import { BoxBodyContainer } from '@components/Box/BoxBodyContainer';
import { BreadcrumbsContainer } from '@components/BreadcrumbsContainer';
import { GridHeaderMenuTitle } from '@components/HeaderTitle';
import { Modal } from '@components/Modal';
import { routes } from '@config/routes';

export const SalesTax = () => {
  const [showCreateTax, setShowCreateTax] = useState(false);
  const refreshListRef = useRef<(() => void) | null>(null);

  const captureRefreshFunction = (refreshFn: () => void) => {
    refreshListRef.current = refreshFn;
  };

  const refreshData = () => {
    if (refreshListRef.current) {
      refreshListRef.current();
    }
  };

  const baseBreadCrumbs = [{ link: 'Settings', to: '' }];

  const isOnRootPath = location.pathname === routes.SALES_TAX;

  const breadCrumbLinks = isOnRootPath
    ? baseBreadCrumbs
    : [...baseBreadCrumbs, { link: 'Sales Tax', to: routes.SALES_TAX }];

  return (
    <>
      <div className="p-4 space-y-4">
        <BreadcrumbsContainer>
          <div className="lg:text-sm md:text-sm text-xs text-gray-500">
            Set-up
          </div>
          <div className="lg:flex md:flex hidden">
            <BreadCrumbs links={breadCrumbLinks} />
          </div>
        </BreadcrumbsContainer>

        <div>
          <div className="flex justify-between items-center space-x-5">
            <BoxHeaderTitle>
              <GridHeaderMenuTitle>
                <div className="lg:text-2xl md:text-xl text-md lg:font-black md:font-black font-bold">
                  Sales Tax
                </div>
              </GridHeaderMenuTitle>
            </BoxHeaderTitle>

            <div className="">
              <div className="flex flex-row space-x-1">
                <AddRecord
                  label="New Sales Tax"
                  onClick={() => setShowCreateTax(true)}
                />
              </div>
              {showCreateTax && (
                <Modal show={true}>
                  <SalesTaxCreate
                    onClose={(refreshGrid?: boolean) => {
                      setShowCreateTax(false);
                      if (refreshGrid) {
                        refreshData();
                      }
                    }}
                  />
                </Modal>
              )}
            </div>
          </div>

          <div className="p-4 bg-white rounded-b-xl rounded-tr-xl">
            <BoxBodyContainer>
              <Outlet context={{ captureRefreshFunction }} />
            </BoxBodyContainer>
          </div>
        </div>
      </div>
    </>
  );
};
